import { zodResolver } from "@hookform/resolvers/zod";
import Grid from "@mui/material/Grid";
import { useUpdateApplicationStatusMutation } from "api/applications/applications.mutation";
import { Button } from "components/LoadingButton";
import { Modal } from "components/Modal";
import RadioField from "components/RadioField";
import TextField from "components/TextField";
import { APPLICATION_STATUS } from "constants/options";
import { handleError } from "functions/apiHandleError";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { schema } from "schema/applicationDetail/submitModal";
import classes from "./style.module.scss";

const SubmitModal = ({ open, onClose, selectedApplication }) => {
  const { control, handleSubmit, setError, reset } = useForm({
    mode: "onChange",
    resolver: zodResolver(schema),
    dafaultValues: {
      application_status: "",
      application_message: "",
    },
  });

  const updateApplicationStatusMutation = useUpdateApplicationStatusMutation();

  const handleCloseModal = () => {
    reset();
    onClose();
  };

  const onSubmit = async (data) => {
    try {
      await updateApplicationStatusMutation.mutateAsync({
        application: selectedApplication.id,
        status: data?.application_status,
        message: data?.application_message,
      });
      handleCloseModal();
      toast.success("با موفقیت ثبت شد");
    } catch (err) {
      handleError({ err, setError });
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      title=""
      maxWidth="sm"
      footerEnd={
        <>
          <Button
            variant="contained"
            size="xsmall"
            loading={updateApplicationStatusMutation.isPending}
            color="success"
            onClick={handleSubmit(onSubmit)}
          >
            ثبت
          </Button>
          <Button variant="contained" color="error" size="xsmall" onClick={handleCloseModal}>
            بستن
          </Button>
        </>
      }
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <RadioField
            label="لطفا وضعیت پرونده را مشخص کنید"
            name="application_status"
            options={APPLICATION_STATUS}
            row
            theme={3}
            control={control}
            required
          />
        </Grid>
        <div className={classes.divider} />
        <Grid item xs={12}>
          <TextField
            multiline
            rows={4}
            variant="filled"
            label="نظر خود را اینجا وارد کنید (اختیاری)"
            control={control}
            name="application_message"
          />
        </Grid>
      </Grid>
    </Modal>
  );
};

export default SubmitModal;
